import React from "react"
import { Field } from "formik"
import { Translate } from "utils/i18n-shim"
import { Chip } from "@mui/material"

import { RemoteAutocomplete } from "shared/ui/berry-jass-formik"
import { getRemoteAutocompleteCreatableTagsProps } from "shared/lib/formik"

export const TagsField = ({ japCustomerId, label, additionalParams = {} }) => {
  const params = {
    jap_customer_id: japCustomerId,
    q: { internal_or_in_clusters: true, unique_names: true },
    ...additionalParams
  }

  return (
    <Field
      paginated
      component={RemoteAutocomplete}
      label={label ?? <Translate value="campaigns.additional-tags" />}
      name="tags"
      variant="ransack"
      searchProp="q.name_cont"
      url="autocomplete/jap_customers/tags"
      mapResponseToDataSource={(response) => response?.data ?? []}
      params={params}
      {...getRemoteAutocompleteCreatableTagsProps()}
      renderTags={(tagValue, getTagProps) =>
        tagValue.map((option, index) => {
          return (
            <Chip
              key={option.name}
              label={option.name}
              color="primary"
              {...getTagProps({ index })}
              sx={{
                "&.MuiChip-root.MuiAutocomplete-tag": {
                  backgroundColor:
                    option.origin === "schalttool" ? "primary.50" : ""
                }
              }}
            />
          )
        })
      }
    />
  )
}
